export const dorkTypes = [
  {
    title: "Search in website Title",
    value: "intitle",
  },
  {
    title: "Search in website URL",
    value: "inurl",
  },
  {
    title: "Search in website Text",
    value: "intext",
  },
  {
    title: "Search Site domain / sub domain",
    value: "site",
  },
  {
    title: "Search definations",
    value: "define",
  },
  // next time create for this
  // "",
  // "",
  // "",
  // "",
  // "",
  // "",
  // "",
  // "",
  {
    title: "Search in phonebooks",
    value: "phonebook",
  },
  {
    title: "Search in Maps",
    value: "maps",
  },
  {
    title: "Search in book",
    value: "book",
  },
  {
    title: "Search details information",
    value: "info",
  },
  {
    title: "Search by Movie Name",
    value: "movie",
  },
  {
    title: "Search Weather Condition",
    value: "weather",
  },
  {
    title: "Search related topics",
    value: "related",
  },
  {
    title: "Search any links",
    value: "link",
  },
];
export const contacts = [
  {
    title: "Github Repository",
    icon: (
      <i
        class="fab fa-github-square inline-block w-full cursor-pointer"
        aria-hidden="true"
      ></i>
    ),
    iconClass: "bg-neutral-800 text-white",
    link: "https://github.com/Shariar-Hasan/Dork-IT",
  },
  {
    title: "Github",
    icon: (
      <i
        class="fab fa-github inline-block w-full cursor-pointer"
        aria-hidden="true"
      ></i>
    ),
    iconClass: "text-white bg-neutral-800",
    link: "https://github.com/Shariar-Hasan/",
  },
  {
    title: "LinkedIn",
    icon: (
      <i
        class="fab fa-linkedin inline-block w-full cursor-pointer"
        aria-hidden="true"
      ></i>
    ),
    iconClass: "text-white bg-blue-700",
    link: "https://www.linkedin.com/in/shariar-hasan/",
  },
  {
    title: "Medium",
    icon: (
      <i
        class="fab fa-medium inline-block w-full cursor-pointer"
        aria-hidden="true"
      ></i>
    ),
    iconClass: "text-white bg-black",
    link: "https://medium.com/@ShariarHasan",
  },
];
